export const USERNAME_MIN_LENGTH = 3;
export const USERNAME_MAX_LENGTH = 20;
export const USERNAME_PATTERN = /^[a-zA-Z0-9_]{3,20}$/;
export const USERNAME_TAKEN_MESSAGE = "Ese username ya está ocupado. Prueba con otro.";

export const normalizeUsername = value => String(value || "").trim().toLowerCase();

export const validateUsername = value => {
  const normalized = normalizeUsername(value);
  if (!normalized) return "Elige un username";
  if (!USERNAME_PATTERN.test(normalized)) return "Solo letras, números y _ (3–20 chars)";
  return "";
};

export const checkUsernameAvailability = async (client, value, excludeUserId = null) => {
  const normalized = normalizeUsername(value);
  const validationError = validateUsername(normalized);
  if (validationError) {
    return { available: false, normalized, reason: "invalid", error: validationError };
  }

  const { data, error } = await client.rpc("is_username_available", {
    candidate: normalized,
    exclude_user_id: excludeUserId || null,
  });

  if (error) {
    const wrapped = new Error(error.message || "No se pudo comprobar la disponibilidad del username");
    wrapped.code = error.code;
    wrapped.details = error.details;
    wrapped.hint = error.hint;
    throw wrapped;
  }

  return {
    available: data === true,
    normalized,
    reason: data === true ? "available" : "taken",
    error: data === true ? "" : USERNAME_TAKEN_MESSAGE,
  };
};

export const isUsernameConflict = error => {
  if (String(error?.code || "") !== "23505") return false;
  const signature = [error?.constraint, error?.message, error?.details, error?.hint]
    .filter(Boolean)
    .join(" ");
  return /users_username|username/i.test(signature);
};
